module.exports = __webpack_public_path__ + "static/media/04_quote_tablet.eb809045.jpg";